import React, { useState, useEffect } from 'react'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { useTranslation } from '@/i18n'

interface GroupNameDialogProps {
  isOpen: boolean
  onClose: () => void
  onConfirm: (name: string) => void
  defaultName?: string
  title?: string
  description?: string
  confirmLabel?: string
}

export const GroupNameDialog: React.FC<GroupNameDialogProps> = ({
  isOpen,
  onClose,
  onConfirm,
  defaultName = '',
  title,
  description,
  confirmLabel,
}) => {
  const { t } = useTranslation()
  const [name, setName] = useState(defaultName)

  useEffect(() => {
    if (isOpen) {
      setName(defaultName)
    }
  }, [isOpen, defaultName])

  const handleConfirm = () => {
    const trimmed = name.trim()
    if (!trimmed) return
    onConfirm(trimmed)
    onClose()
  }

  return (
    <Dialog open={isOpen} onOpenChange={(open) => { if (!open) onClose() }}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>
            {title || t('data_catalog:graph_editor.multi_page_set.name_group_title')}
          </DialogTitle>
          <DialogDescription>
            {description || t('data_catalog:graph_editor.multi_page_set.name_group_description')}
          </DialogDescription>
        </DialogHeader>
        <Input
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder={t('data_catalog:graph_editor.multi_page_set.name_group_placeholder')}
          onKeyDown={(e) => { if (e.key === 'Enter') handleConfirm() }}
          autoFocus
        />
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>
            {t('common:buttons.cancel', 'Cancel')}
          </Button>
          <Button onClick={handleConfirm} disabled={!name.trim()}>
            {confirmLabel || t('common:buttons.confirm', 'Confirm')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
